import { axiosInstance } from './common';

export const listCamerasWithSensors = () =>
  axiosInstance.get('/cameras', { params: { withSensors: true } }).then((r) => r.data);

export const startLive = (cameraId) =>
  axiosInstance.post(`/cameras/${cameraId}/live`).then((r) => r.data);

export const stopLive = (cameraId) =>
  axiosInstance.delete(`/cameras/${cameraId}/live`).then((r) => r.data);
